
import { Helmet } from "react-helmet";
import WisdomToothPage from "@/components/services/wisdom-tooth/WisdomToothPage";

const WisdomToothRemoval = () => {
  return (
    <>
      <Helmet>
        <title>Wisdom Tooth Removal in Nagpur | Cost of Wisdom Tooth Removal in Nagpur</title>
        <meta
          name="description"
          content="Get expert wisdom tooth removal in Nagpur at Asrani Dental Clinic. Safe, painless extraction by experienced dentists. Book your consultation today!"
        />
      </Helmet>
      
      <WisdomToothPage />
    </>
  );
};

export default WisdomToothRemoval;
